module.exports = __webpack_public_path__ + "static/media/bank_details_character.ffbbf343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank_details_character.png
// module id = 1107
// module chunks = 21